var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('hr',{staticClass:"custom-divider",style:('border-top:'+_vm.currentField.maxheight+'px '+_vm.currentField.dividerType+' '+ _vm.currentField.color+';width:'+_vm.currentField.maxwidth+'%;')})])}
var staticRenderFns = []

export { render, staticRenderFns }